

import { useDateFormat } from "../../Context/DateFormat";
import Moment from 'moment';


export default function NuDate(props) {
  const { add, addString, showTime } = props; // new prop `showTime`
  const { dateFormat } = useDateFormat();

  if (!props.value) return '';

  const formatString = showTime 
    ? (dateFormat || 'DD-MM-YYYY') + ' hh:mm a' // e.g., 23-09-2025 10:52 am
    : (dateFormat || 'DD-MM-YYYY');

  return Moment(props.value)
    .add(add || 0, addString || 'd')
    .format(formatString);
}

// utils/formatDate.js
export function formatDate(date, format = "DD-MMM-YYYY") {
  const d = new Date(date);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(/ /g, "-");
}



// import Moment from 'moment';

// export default function NuDate(props) {
//   //add string
//   // d=>days
//   // Y=>year
//   // M=>months
//   // w=>weeks
//   // h=>hours
//   // m=>minuites
//   // s=>seconds

//   const { format, add, addString } = props;
//   if (!props.value) {
//     return '';
//   }

//   return Moment(props.value)
//     .add(add ? add : 0, addString ? addString : 'd')
//     .format(`${format ? format : 'DD-MM-YYYY'}`);
// }
